import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'pd.glamourDay.title',
    defaultMessage: 'GLAMOUR',
  },
  description: {
    id: 'pd.glamourDay.description',
    defaultMessage:
      'Kupte časopis a získejte slevový kód, více informací <a>zde</a>.',
  },
});
